import attr from 'epa-components-platform/src/lib/helper/js/attrModule';
import modules from './modules';
import { QueryStringKeeper } from './services';

const loadApp = () => {
  const moduleElements = document.querySelectorAll('[data-module]');

  for (let i = 0; i < moduleElements.length; i++) {
    const element = moduleElements[i];
    const name = element.getAttribute('data-module');

    const data = attr(element);

    if (modules[name]) {
      new modules[name](element, data);
    }
  }

  // Сервис для сохранения query параметров
  QueryStringKeeper.keepQueryString();
}

loadApp();